import React from "react";
import {
  NewAdBar,
  CampaignForm,
  AdDashboardNav,
  AdSidebar,
  Loading,
  CampaignAwareness,
} from "../../../components";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GET_USER_DETAILS } from "../../../apollo/operations";
import { setUserDetails } from "../../../redux/slices/userSlice";
import { showToast } from "../../../utils/showToast";
import { useQuery } from "@apollo/client";

const NewAd: React.FC = () => {
  const dashboardMenu = [
    {
      name: "Overview",
    },
    {
      name: "Get Started",
    },
    {
      name: "Ads",
    },
    {
      name: "Help",
    },
  ];

  const [active, setActive] = React.useState<string>(dashboardMenu[2].name);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [openCampaignAwareness, setOpenCampaignAwareness] =
    React.useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userID = window.localStorage.getItem("user");

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading, error, data, refetch } = useQuery(GET_USER_DETAILS, {
    variables: {
      where: {
        id: userID,
      },
    },
    onCompleted: (data) => {
      console.log(data.user);
      dispatch(setUserDetails(data.user));
    },
    onError: (error) => {
      console.log(error);

      showToast(error.message, "error");
      navigate("/auth");
    },
  });

  if (loading) return <Loading loading={loading} />;
  return (
    <div className="overflow-x-hidden overscroll-none  h-full bg-comPagBg pl-[18%] py-[10%]">
      <AdSidebar
        active={active}
        setActive={setActive}
        setIsOpen={setIsOpen}
        dashboardMenu={dashboardMenu}
      />
      {data && (
        <div className="w-full flex flex-col z-20 lg:fixed lg:left-full lg:bg-[#fbfafa]">
          <AdDashboardNav
            active={active}
            toggleSidebar={toggleSidebar}
            data={data}
            isOpen={isOpen}
          />
        </div>
      )}
      <div
        className={`gap-10 flex flex-col font-Poppins pr-[12%] ${
          openCampaignAwareness ? "pr-[19%]" : ""
        }`}
      >
        <NewAdBar />
        {!openCampaignAwareness ? (
          <CampaignForm
            openCampaignAwareness={openCampaignAwareness}
            setOpenCampaignAwareness={setOpenCampaignAwareness}
          />
        ) : (
          <CampaignAwareness />
        )}
      </div>
    </div>
  );
};

export default NewAd;
